import PropTypes from 'prop-types';
import classnames from 'classnames';

const Subheader = ({ children, backgroundColor }) => {
  const classes = {
    'h2': true,
    'h3-ns': true,
    'dt': 'true',
    'w-100': true,
    'bg-near-black': backgroundColor === 'near-black',
    'bg-near-white': backgroundColor === 'near-white',
  };

  return <div className={classnames(classes)}>{children}</div>;
};

Subheader.defaultProps = {
  backgroundColor: null,
};

Subheader.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
};

export default Subheader;
